<template>
    <div class="section" style="padding-top: 70px;">
        <app-loader :loading="getLoaderStatus"
                    :color="options.color"
                    :size="options.size"
                    class="fixed-center">
        </app-loader>
        <div class="columns" v-if="!getLoaderStatus">
            <div class="column">
                <welcome></welcome>
            </div>
        </div>
        <!--<div class="columns" v-if="!getLoaderStatus">-->
            <!--<notifications></notifications>-->
        <!--</div>-->
        <div class="columns" v-if="!getLoaderStatus">
            <div class="column">
                <rates></rates>
            </div>
        </div>
        <div class="columns" v-if="!getLoaderStatus && isAdmin">
            <div class="column">
                <manager-bids></manager-bids>
            </div>
            <div class="column">
                <manager-users></manager-users>
            </div>
            <div class="column">
                <manager-purchases></manager-purchases>
            </div>
            <div class="column is-one-third">
                <manager-requests></manager-requests>
            </div>
        </div>
        <div class="columns" v-if="!getLoaderStatus && isAdmin">
            <div class="column">
                <manager-late-payments></manager-late-payments>
            </div>
            <div class="column">
                <manager-payments-caught></manager-payments-caught>
            </div>
            <div class="column">
                <manager-cars-in-japan></manager-cars-in-japan>
            </div>
            <div class="column is-one-third">
                <manager-inquiry></manager-inquiry>
            </div>
        </div>
        <div class="columns" v-if="!getLoaderStatus && isAdmin">
            <div class="column">
                <manager-cars-on-transit></manager-cars-on-transit>
            </div>
            <div class="column">
                <manager-vessel-arrived-due></manager-vessel-arrived-due>
            </div>
            <div class="column">
                <manager-unissued-invoices></manager-unissued-invoices>
            </div>
            <div class="column is-one-third">
                <manager-unsigned-clients></manager-unsigned-clients>
            </div>
        </div>
        <div class="columns" v-if="!getLoaderStatus">
            <div class="column">
                <auctions></auctions>
            </div>
            <div class="column">
                <stock></stock>
            </div>
            <div class="column">
                <one-price></one-price>
            </div>
            <div class="column is-one-third">
                <news v-if="isAdmin"></news>
            </div>
        </div>
        <div class="columns" v-if="!getLoaderStatus && !isAdmin">
            <div class="column">
                <bidding></bidding>
            </div>
        </div>
        <div class="columns" v-if="!getLoaderStatus && !isAdmin">
            <div class="column">
                <exports></exports>
            </div>
        </div>
        <div class="columns" v-if="!getLoaderStatus && !isAdmin">
            <div class="column">
                <payables></payables>
            </div>
            <div class="column">
                <due-dates></due-dates>
            </div>
            <div class="column">
                <pending></pending>
            </div>
        </div>
        <div class="columns" v-if="!getLoaderStatus && !isAdmin">
            <div class="column">
                <payments></payments>
            </div>
            <div class="column">
                <contacts></contacts>
            </div>
            <div class="column">
                <manager></manager>
            </div>
        </div>
        <div class="columns" v-if="!getLoaderStatus && !isAdmin">
            <div class="column">
                <profile></profile>
            </div>
            <div class="column">
                <coupon></coupon>
            </div>
        </div>
        <div class="columns" v-if="!getLoaderStatus && isAdmin">
            <div class="column">
                <inland-calculator></inland-calculator>
            </div>
            <div class="column">

            </div>
            <div class="column">

            </div>
        </div>
    </div>
</template>

<script>
    import appLoader from 'vue-spinner/src/ClipLoader'
    import Rates from './Dashboard/Rates.vue'
    import Welcome from './Dashboard/Welcome.vue'
    import News from './Dashboard/News.vue'
    import Auctions from './Dashboard/Auctions.vue'
    import Stock from './Dashboard/Stock.vue'
    import OnePrice from './Dashboard/OnePrice.vue'
    import Bidding from './Dashboard/Bidding.vue'
    import Exports from './Dashboard/Exports.vue'
    import Payables from './Dashboard/Payables.vue'
    import DueDates from './Dashboard/DueDates.vue'
    import Pending from './Dashboard/Pending.vue'
    import Payments from './Dashboard/Payments.vue'
    import Contacts from './Dashboard/Contacts.vue'
    import Manager from './Dashboard/Manager.vue'
    import Notifications from './Dashboard/Notifications.vue'
    import Coupon from './Dashboard/Coupon.vue'
    import Profile from './Dashboard/Profile.vue'
    import InlandCalculator from './Tools/Calculators/InlandCalculator.vue'

    import ManagerBids from './Dashboard/Manager/Bids.vue'
    import ManagerRequests from './Dashboard/Manager/Requests.vue'
    import ManagerUsers from './Dashboard/Manager/Users.vue'
    import ManagerPurchases from './Dashboard/Manager/Purchases.vue'
    import ManagerLatePayments from './Dashboard/Manager/LatePayments.vue'
    import ManagerPaymentsCaught from './Dashboard/Manager/PaymentsCaught.vue'
    import ManagerCarsInJapan from './Dashboard/Manager/CarsInJapan.vue'
    import ManagerInquiry from './Dashboard/Manager/Inquiry.vue'
    import ManagerCarsOnTransit from './Dashboard/Manager/CarsOnTransit.vue'
    import ManagerVesselArrivedDue from './Dashboard/Manager/VesselArrivedDue.vue'
    import ManagerUnissuedInvoices from './Dashboard/Manager/UnissuedInvoices.vue'
    import ManagerUnsignedClients from './Dashboard/Manager/UnsignedClients.vue'
    export default {
        components: {
            News,
            Welcome,
            Rates,
            Auctions,
            Stock,
            OnePrice,
            Bidding,
            Exports,
            Payables,
            DueDates,
            Pending,
            Payments,
            Contacts,
            Manager,
            appLoader,
            Notifications,
            Coupon,
            Profile,
            InlandCalculator,

            ManagerBids,
            ManagerRequests,
            ManagerUsers,
            ManagerPurchases,
            ManagerLatePayments,
            ManagerPaymentsCaught,
            ManagerCarsInJapan,
            ManagerInquiry,
            ManagerCarsOnTransit,
            ManagerVesselArrivedDue,
            ManagerUnissuedInvoices,
            ManagerUnsignedClients
        },
        data() {
            return {
                options: this.$store.getters.getOptions
            }
        },
        created () {
            this.$store.dispatch('fetchCurrentLoginUser')
        },
        methods: {
            isRole(role) {
                if (this.$store.getters.getUserRole === role) {
                    return true
                }
            }
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue